import kaplay from "kaplay";

import { loadAllAssets } from "@/utils/loadAssets.js";
import { startScene } from "@/presentation/scenes/startScene.js";
import { introScene } from "@/presentation/scenes/introScene.js";
import { menuScene } from "@/presentation/scenes/menuScene.js";
import { gameScene } from "@/presentation/scenes/game/gameScene.js";
import { gameOverScene } from "@/presentation/scenes/gameOverScene.js";

// Initialize KAPLAY
const k = kaplay({
    global: false,
    width: 1152,         // (64 * 18) Lock the internal game resolution
    height: 512,         // (64 * 8) Lock the internal game resolution
    letterbox: true,
    crisp: true,
    pixelDensity: 1,
    background: [0, 0, 0],
});

// k.debug.inspect = true;

document.addEventListener("touchend", () => {
    k.audioCtx.resume();
}, { once: true });

// Load Assets
loadAllAssets(k);

// Register Scenes
k.scene("start", () => startScene(k));
k.scene("intro", () => introScene(k));
k.scene("menu", () => menuScene(k));
k.scene("game", (playerCount) => gameScene(k, playerCount));
k.scene("gameOver", (winner) => {
    gameOverScene(k, winner);
});

// Start the game
k.go("menu");
// k.go("game");